import { Table, TableCaption, TableContainer, Tbody, Td, Th, Thead, Tr, Text, Link } from "@chakra-ui/react";
import { FC } from "react";
import Number from "components/number-format";
import moment from "moment";

interface TableHeaderProps {
    label: string;
    isNumeric?: boolean
}

interface TableRowProps {
    propertyName?: string;
    isNumeric?: boolean;
    isDate?: boolean;
    isDatetime?: boolean;
    prefix?: string;
    render?: any;
    baseUrl?: string;
}

interface TableProps {
    caption?: string;
    variant?: string;
    headers: TableHeaderProps[];
    rows: TableRowProps[];
    data: any;
    onRowClick?: any;
};

const LogosTable: FC<TableProps> = ({ caption, variant, headers, rows, data, onRowClick }) => {
    const getObjectByString = function (o: any, s: string) {
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, '');           // strip a leading dot
        var a = s.split('.');
        for (var i = 0, n = a.length; i < n; ++i) {
            var k = a[i];
            if (k in o) {
                o = o[k];
            } else {
                return;
            }
        }
        return o;
    }

    return (
        <TableContainer>
            <Table variant={variant || 'striped'} size={"sm"}>
                {caption && <TableCaption placement={'top'} fontSize={'xl'} fontWeight={'bold'} textAlign={'left'}>{caption}</TableCaption>}
                <Thead>
                    <Tr>
                        {
                            headers.length > 0 &&
                            headers.map((header: TableHeaderProps, index: number) => {
                                return (
                                    <Th
                                        key={index}
                                        isNumeric={header.isNumeric}
                                    >
                                        {header.label}
                                    </Th>
                                );
                            })
                        }
                    </Tr>
                </Thead>
                <Tbody>
                    {
                        data.length > 0 &&
                        data.map((item: any, index: number) => {

                            return (
                                <Tr
                                    key={index}
                                    onClick={() => { onRowClick(item) }}
                                    cursor={onRowClick ? 'pointer' : ''}
                                >
                                    {
                                        rows.length > 0 &&
                                        rows.map((row: TableRowProps, index: number) => {
                                            var value = !row.render && getObjectByString(item, row.propertyName || "");
                                            return (
                                                <Td
                                                    key={index}
                                                    isNumeric={row.isNumeric}
                                                >
                                                    {
                                                        row.baseUrl ?
                                                            <Link href={row.baseUrl + item.id} textDecoration={"underline"}>
                                                                {
                                                                    row.render && row.render(item)
                                                                }
                                                                {
                                                                    !row.render && row.isNumeric &&
                                                                    <Number value={value} prefix={row.prefix ? row.prefix : ''} />
                                                                }
                                                                {
                                                                    !row.render && row.isDatetime &&
                                                                    moment(value).format("DD MMMM yyyy HH:mm")
                                                                }
                                                                {
                                                                    !row.render && row.isDate &&
                                                                    moment(value).format("DD MMMM yyyy")
                                                                }
                                                                {
                                                                    !row.render && !row.isNumeric && !row.isDatetime && !row.isDate &&
                                                                    value
                                                                }
                                                            </Link>
                                                            :
                                                            <>
                                                                {
                                                                    row.render && row.render(item)
                                                                }
                                                                {
                                                                    !row.render && row.isNumeric &&
                                                                    <Number value={value} prefix={row.prefix ? row.prefix : ''} />
                                                                }
                                                                {
                                                                    !row.render && row.isDatetime &&
                                                                    moment(value).format("DD MMMM yyyy HH:mm")
                                                                }
                                                                {
                                                                    !row.render && row.isDate &&
                                                                    moment(value).format("DD MMMM yyyy")
                                                                }
                                                                {
                                                                    !row.render && !row.isNumeric && !row.isDatetime && !row.isDate &&
                                                                    value
                                                                }
                                                            </>
                                                    }

                                                </Td>
                                            );
                                        })
                                    }
                                </Tr>
                            );
                        })
                    }

                    {
                        data.length === 0 &&
                        <Tr>
                            <Td py={10} colSpan={headers.length} textAlign={'center'} fontSize={'sm'} color={'red.500'}>Tidak ada data yang ditemukan.</Td>
                        </Tr>
                    }
                </Tbody>
                {/*<Tfoot>*/}
                {/*    <Tr>*/}
                {/*        <Th>To convert</Th>*/}
                {/*        <Th>into</Th>*/}
                {/*        <Th isNumeric>multiply by</Th>*/}
                {/*    </Tr>*/}
                {/*</Tfoot>*/}
            </Table>
        </TableContainer>
    );
};

export default LogosTable;